<!DOCTYPE html>
<ion-content>
  <ion-row class="close-btn-wrapper" justify-content-end>
    <ion-col size="auto">
      <ion-button fill="clear" (click)="closeDialog()" class="cross-btn">
        <img src="assets/images/cross-img.png" alt="close" />
      </ion-button>
    </ion-col>
  </ion-row>
  <ion-row class="loader-container" justify-content-center>
    <ion-col size="12" text-center>
      @if (showLoader) {
        <div class="loader-wrapper">
          <div class="loader-box">
            <div class="loader"></div>
          </div>
          <div class="loader-text">
            {{ "api_loader.loading_text" | translate }}
          </div>
        </div>
      }
      @if (!showLoader && isSuccess) {
        <div class="checkmark-wrapper">
          <div class="success-checkmark">
            <div class="check-icon">
              <span class="icon-line line-tip"></span>
              <span class="icon-line line-long"></span>
              <div class="icon-circle"></div>
              <div class="icon-fix"></div>
            </div>
          </div>
          <div class="success-text">
            {{ "api_loader.success_text" | translate }}
          </div>
        </div>
      }
      @if (!showLoader && isFailure) {
        <div class="cross-wrapper">
          <div class="failure-crossmark">
            <div class="cross-icon">
              <span class="icon-line line-left-cross"></span>
              <span class="icon-line line-right-cross"></span>
              <div class="icon-circle"></div>
            </div>
          </div>
          <div class="failure-text">
            {{ "api_loader.failure_text" | translate }}
          </div>
        </div>
      }
      @if (!showLoader && isTimeout) {
        <div class="timeout-wrapper">
          <div class="timeout-animation">
            <div class="circle">
              <div class="hand"></div>
              <div class="cross-line line-left"></div>
              <div class="cross-line line-right"></div>
            </div>
          </div>
          <div class="timeout-text">
            {{ "api_loader.timeout_text" | translate }}
          </div>
        </div>
      }
    </ion-col>
  </ion-row>
</ion-content>
